// Mark: Used in V2
import React from "react"

import { Color } from "../../constants/V2/color"
import { getTextColorClass } from "../../utils/V2/color"

type Props = {
  text: string
  color?: Color
  animationSpeed?: number
  lineColor?: Color
}
const LoaderV2 = ({
  text,
  color = Color.Black,
  animationSpeed = 1.5,
  lineColor = Color.LightBlue,
}: Props) => {
  const loaderSize = 80

  return (
    <svg viewBox={`0 0 100 ${loaderSize}`} width="100%" height={loaderSize}>
      <text
        y="40%"
        fontSize={loaderSize * 0.25}
        fontFamily="sharp-grotesk-20"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="currentColor"
        fontWeight="bold"
        className={getTextColorClass(color)}
      >
        <tspan x="50" textAnchor="middle">
          {text}
        </tspan>
      </text>
      <line
        x1="10"
        y1={loaderSize * 0.85}
        x2="90"
        y2={loaderSize * 0.85}
        strokeWidth={loaderSize * 0.03}
        strokeLinecap="round"
        strokeDasharray="100"
        stroke="currentColor"
        strokeDashoffset="100"
        className={getTextColorClass(lineColor)}
      >
        <animate
          attributeName="stroke-dashoffset"
          from="100"
          to="0"
          dur={`${animationSpeed}s`}
          repeatCount="indefinite"
        />
      </line>
    </svg>
  )
}

export default LoaderV2
